import React from 'react';
import styled from 'styled-components';

// Define the coding profiles data
const codingprofile = [
  {
    id: 0,
    profile: "LeetCode",
    link: "https://leetcode.com/u/Bhavy_zala21/",
    maxrating: "1850+ (Top 5%)",
    problems_solved: "800+",
  },
  {
    id: 1,
    profile: "Coding Ninjas",
    link: "https://www.naukri.com/code360/profile/Bhavy_Zala",
    maxrating: "3091 (Top 2%)",
    problems_solved: "260+",
  },
  {
    id: 2,
    profile: "Codeforces",
    link: "https://codeforces.com/profile/Bhavy_Zala",
    maxrating: "1208 (Pupil)",
    problems_solved: "390+",
  },
  {
    id: 3,
    profile: "Codechef",
    link: "https://www.codechef.com/users/codemaster_21",
    maxrating: "1628 (3 Star)",
    problems_solved: "20+",
  },
  {
    id: 4,
    profile: "Geeksforgeeks",
    link: "https://www.geeksforgeeks.org/user/zalabhah312/",
    problems_solved: "325+",
  },
  {
    id: 5,
    profile: "GitHub",
    link: "https://github.com/zalabhavy",
    decs1: "I have made a total of 250+ PRs, of which 190+ PRs have been merged. GSSoC'24 Top 10 Contrubutor and GSSoC'24 Extd Top Mentor.I am Contributor in Fultter Doc & AsyncAPI Organizations"
  }
];

const data = [
  { id: 0, text: "Ranked 332 out of 52,000+ participants in the Coding Ninjas World Cup." },
  { id: 1, text: "Solved 1500+ coding problems and contributed to Google's open-source project and developer communities." },
  { id: 2, text: "Earned the Microsoft Certified: Fabric Analytics Engineer Associate (DP-600) credential." },
  { id: 3, text: "Certified in Next-Gen Productivity: Copilot + Agents for the Modern Enterprise." },
  { id: 4, text: "I have a Basic Problem Solving certificate from HackerRank." },
  { id: 5, text: "I completed the Arcade event, learning about Google Cloud and receiving goodies from Google." },
  { id: 6, text: "I received goodies twice for my 200 days of POTD solving from GeeksforGeeks." }
];

// Styled components
const Title = styled.h2`
  font-size: 42px;
  text-align: center;
  margin-bottom: 50px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  margin-top: 60px;
  @media (max-width: 768px) {
    font-size: 32px;
    margin-top: 100px;
  }
`;

const ProfileBox = styled.div`
  width: 100%;
  max-width: 700px; /* Adjust max-width as needed */
  background: ${({ theme }) => theme.card};
  border: 1px solid #854ce6;
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
  border-radius: 16px;
  padding: 16px 20px;
  margin: 0 auto 20px;
  cursor: pointer;
  transition: transform 0.3s ease-in-out;
  word-wrap: break-word; /* Ensures text wraps correctly */
  &:hover {
    transform: scale(1.03) translateY(-5px);
  }
  @media (max-width: 768px) {
    padding: 10px 16px; /* Adjust padding for smaller screens */
    max-width: calc(100% - 40px); /* Adjust max-width for smaller screens */
  }
`;

const ProfileData = styled.div`
  font-size: 1rem;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 10px;
  text-indent: -1.5rem; /* Adjust based on the size of the arrow */
  padding-left: 1.5rem; /* Align subsequent lines */
  white-space: pre-line; /* Preserves whitespace but allows for wrapping */
  &:before {
    content: '→';
    color: ${({ theme }) => theme.primary};
    margin-right: 10px;
  }
`;

const ProfileLink = styled.a`
  color: ${({ theme }) => theme.primary};
  text-decoration: none;
  font-weight: bold;
  &:hover {
    text-decoration: underline;
  }
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  flex-direction: column;
  width: 100%;
  max-width: 1550px;
  padding: 40px 0px 0px 0px;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const ProfileTitle = styled.h3`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 10px;
`;

const Bullet = styled.span`
  font-size: 1.5rem;
  color: ${({ theme }) => theme.primary};
  margin-right: 10px;
`;

const AchievementsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const AchievementItem = styled.li`
  font-size: 1rem;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 10px;
  text-indent: -1.5rem; /* Adjust based on the size of the arrow */
  padding-left: 1.5rem; /* Align subsequent lines */
  white-space: pre-line; /* Preserves whitespace but allows for wrapping */
  &:before {
    content: '→';
    color: ${({ theme }) => theme.primary};
    margin-right: 10px;
  }
`;

const Achievements = () => {
  return (
    <div id='achievements'>
      <Wrapper>
        <Title>Achievements</Title>
        {codingprofile.map(profile => (
          <ProfileBox key={profile.id}>
            <ProfileTitle>
              <Bullet>&rarr;</Bullet>
              {profile.profile}
            </ProfileTitle>
            <ProfileData>
              <ProfileLink href={profile.link} target="_blank" rel="noopener noreferrer">
                {`${profile.profile} Profile`}
              </ProfileLink>
            </ProfileData>
            {profile.maxrating && (
              <ProfileData>
                <strong>Max Rating:</strong> {profile.maxrating}
              </ProfileData>
            )}
            {profile.problems_solved && (
              <ProfileData>
                <strong>Problems Solved:</strong> {profile.problems_solved}
              </ProfileData>
            )}
            {profile.decs1 &&(
              <ProfileData>
                {profile.decs1}
              </ProfileData>
            )}
          </ProfileBox>
        ))}
        <ProfileBox>
          <AchievementsList>
            {data.map(item => (
              <AchievementItem key={item.id}>
                {item.text}
              </AchievementItem>
            ))}
          </AchievementsList>
        </ProfileBox>
      </Wrapper>
    </div>
  );
};

export default Achievements;
